import { LitElement, html } from 'lit'

class ThemeToggle extends LitElement {
    static properties = {
        isDark: { type: Boolean }
    }

    // Use open DOM for Tailwind styling
    createRenderRoot() {
        return this
    }

    constructor() {
        super()
        this.isDark = false
        this.updateThemeClass()
    }

    connectedCallback() {
        super.connectedCallback()
        // Listen for theme changes
        window.addEventListener('theme-changed', this.handleThemeChange.bind(this))
        
        // Set initial state
        if (window.themeManager) {
            this.isDark = window.themeManager.getCurrentTheme() === 'dark'
            this.updateThemeClass()
        }
    }

    disconnectedCallback() {
        super.disconnectedCallback()
        window.removeEventListener('theme-changed', this.handleThemeChange.bind(this))
    }

    handleThemeChange(event) {
        this.isDark = event.detail.theme === 'dark'
        this.updateThemeClass()
    }

    updateThemeClass() {
        if (this.isDark) {
            this.classList.add('dark')
        } else {
            this.classList.remove('dark')
        }
    }

    toggleTheme() {
        if (window.themeManager) {
            window.themeManager.toggleTheme()
        }
    }

    render() {
        return html`
            <div class="flex items-center gap-2 p-2 bg-transparent rounded-xl transition-all duration-200">
                <sl-icon library="fa-solid" name="fa-sun" class="w-5 h-5 text-gray-600 dark:text-gray-300 transition-opacity duration-200 ${this.isDark ? 'opacity-50' : 'opacity-100'}"></sl-icon>
                <sl-switch
                    ?checked="${this.isDark}"
                    @sl-change="${this.toggleTheme}"
                    size="small">
                </sl-switch>
                <sl-icon library="fa-solid" name="fa-moon" class="w-5 h-5 text-gray-600 dark:text-gray-300 transition-opacity duration-200 ${this.isDark ? 'opacity-100' : 'opacity-50'}"></sl-icon>
            </div>
        `
    }
}

customElements.define('theme-toggle', ThemeToggle)